/* Site-Specific JavaScript */

// Matches the height of the given slick slider's slides
function handleEqualHeightSlides(slider_id) {
    jq(slider_id).addClass('match-height'); // this style is located in style.scss
    var slickTrackHeight = jq(slider_id + ' .slick-track').height();
    jq(slider_id + ' .slick-slide').css('height', slickTrackHeight  + 'px' );
}

jq(document).ready(function () {
    // Generic slider
    if (jq(".slider").length) {
        jq(".slider").slick(JSON.parse(document.getElementById("sliderSlickOptions").innerText));
    }
    // slide change event for row-text-and-slider snippet
    if(jq(".crew-slider").length) {
        jq(".crew-slider").on('beforeChange', function (event, slick, slideIndex) {
            jq("#crew-text-" + slideIndex).removeClass('visible');
        });
        jq(".crew-slider").on('afterChange', function (event, slick, slideIndex) {
            jq("#crew-text-" + slideIndex).addClass('visible');
        });
        window.addEventListener("resize", function () {
            jq(".crew-slider").slick('resize');
        });
    }
    //Key Highlights Table
    if (jq('.highlight-chart').length) {
        jq('.highlight-chart th').click(function(e){
            let columnTarget = '[data-column="'+jq(this).attr('data-column')+'"]';
            jq('.active-column').removeClass('active-column');
            jq(columnTarget).addClass('active-column');
        });
    }
    // Key Highlights
    jq('.highlight-header').click(function(e){
        let target = '[data-item="'+jq(this).attr('data-target')+'"]';
        jq('.highlight-header').removeClass('active');
        jq('.highlight-item').hide();
        jq(this).addClass('active');
        jq(target).fadeIn(300);     
    });
    //Start UserSnap - commenting out for push. 
    // window.onUsersnapLoad = function(api) {
    //     api.init();
    // }
    // var script = document.createElement('script');
    // script.defer = 1;
    // script.src = 'https://widget.usersnap.com/global/load/d27250d4-3aa6-46e6-9c4c-f05974aeeeff?onload=onUsersnapLoad';
    // document.getElementsByTagName('head')[0].appendChild(script);
    //End UserSnap
});
